<template>
  <div id="hres7fe-detail-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES7FEC2']['50'] }}
      </h3>
    </div>
    <div id="tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">   
          <div class="detail detail-responsive">
            <div class="col-md-6">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['140'] }}</label>
                  <div class="col-md-6">
                    <textarea class="form-control" 
                              v-model="detailTab2.dessummary"
                              maxlength="600" 
                              v-validate="'max:600'"
                              data-vv-name="dessummary"
                              :has-error="errors.has('dessummary')"></textarea>
                    <div class="text-error" v-show="errors.has('dessummary')">{{errors.first('dessummary')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['150'] }}</label>
                  <div class="col-md-6">
                    <textarea class="form-control" 
                              v-model="detailTab2.desbenefit"
                              maxlength="600" 
                              v-validate="'max:600'"
                              data-vv-name="desbenefit"
                              :has-error="errors.has('desbenefit')"></textarea> 
                    <div class="text-error" v-show="errors.has('desbenefit')">{{errors.first('desbenefit')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-6">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES7FEC2']['160'] }}</label>
                  <div class="col-md-6">
                    <textarea class="form-control" 
                              v-model="detailTab2.descomment"
                              maxlength="600" 
                              v-validate="'max:600'"
                              data-vv-name="descomment"
                              :has-error="errors.has('descomment')"></textarea>
                    <div class="text-error" v-show="errors.has('descomment')">{{errors.first('descomment')}}</div>
                    <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-12">
              <button type="button" class="btn bg-color-skin" @click="save()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>  
            </div>


          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hres7fe-detail-tab2',
  props: [ 'labels', 'detailTab2', 'labelsButton', 'postHres7feTab2Save', 'searchIndex', 'indexSelected' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        searchIndex: this.searchIndex,
        indexSelected: this.indexSelected,
        detailTab2: this.detailTab2
      }
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHres7feTab2Save(_this.saveParams())
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab2.vue?1256bad2